import React from 'react'
import { withRouter } from 'react-router-dom'

import { FeatureBottom } from './FeatureBottom'

import { isAnyPartOfElementInViewport } from '../../actions/actions'

class LocalOpportunities extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      listenerComplete: false
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    this.handleScroll(null)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (this.state.listenerComplete) {
      return
    }

    const itms = document.querySelectorAll('.section:not(.has-been-viewed)')

    if (itms.length <= 0) {
      this.setState({ ...this.state, listenerComplete: true })

      return
    }

    itms.forEach(selectedEle => {
      //console.log(selectedEle, this.isAnyPartOfElementInViewport(selectedEle))
      if (isAnyPartOfElementInViewport(selectedEle)) {
        selectedEle.classList.add('has-been-viewed')
      }
    })
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="row">
            <h2 className="page-title">Your Work-Based Learning Solution</h2>
          </div>
        </div>
        <div
          className="title-block-bar"
          style={{ paddingTop: '75px', backgroundColor: '#FF8300' }}>
          <div className="container">
            <div className={'row'}>
              <div className={'col-sm-7'}>
                <p style={{ fontSize: '1.2rem' }}>
                  The <b>Local Opportunities Network</b> is an online discovery platform
                  that connects students with the local opportunities, including
                  companies, programs and organizations that put their career plans into
                  action. Connect learning with earning by promoting work-based learning,
                  paid internships, field trips and more to all your students via the
                  CareerExplorer.
                </p>
              </div>
              <div className="col-sm-5">
                <img
                  src="/images/www/new/wbl/WBL-HeaderImg.svg"
                  className="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="section">
            <h3>Why Local Opportunities?</h3>
          </div>
          <div className="col-sm-6" style={{ marginTop: '40px', marginBottom: '40px' }}>
            <div style={{ clear: 'left' }}>
              <div
                style={{ width: '120px', marginRight: '20px' }}
                className={'pull-left'}>
                <img
                  style={{ maxHeight: '80px' }}
                  src="/images/www/new/localopps/LocalOpp-Icon-Company.svg"
                  alt="icon of a company building"
                />
              </div>
              <div style={{ width: 'calc(100% - 140px)' }} className={'pull-left'}>
                <h3>Companies Want Inspired Talent</h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  Students can discover local opportunities by searching for them by
                  industry sector, type of opportunity or discovering them via their own
                  career exploration experience.
                </p>
              </div>
            </div>
            <div style={{ clear: 'left' }}>
              <div
                style={{ width: '120px', marginRight: '20px' }}
                className={'pull-left'}>
                <img
                  style={{ maxHeight: '80px' }}
                  src="/images/www/new/localopps/LocalOpp-Icon-Equity.svg"
                  alt="icon of a balancing scale representing equity"
                />
              </div>
              <div style={{ width: 'calc(100% - 140px)' }} className={'pull-left'}>
                <h3>An Equity-Driven Solution</h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  Now all students will have access to the same local opportunities,
                  improving visibility, reducing the administrative load of individual
                  counselors and promoting equality.
                </p>
              </div>
            </div>
            <div style={{ clear: 'left' }}>
              <div
                style={{ width: '120px', marginRight: '20px' }}
                className={'pull-left'}>
                <img
                  style={{ maxHeight: '80px' }}
                  src="/images/www/new/localopps/LocalOpp-Icon-Tracking.svg"
                  alt="icon of a computer with graphics on it"
                />
              </div>
              <div style={{ width: 'calc(100% - 140px)' }} className={'pull-left'}>
                <h3>Tracking Participation and Outcomes</h3>
                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The <b>Local Opportunities Network</b> makes it easy for educators to
                  closely monitor student participation, feedback and next steps.
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="monitor-wrap">
              <div className="embed-responsive embed-responsive-16by9">
                <video
                  id="webinar-video"
                  poster="/images/www/new/localopps/localopp-poster.png"
                  className="embed-responsive-item"
                  controls>
                  <source
                    type="video/mp4"
                    src="https://h2-training.s3.amazonaws.com/Introducing+the+Local+Opportunities+Network+from+Headed2.mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="title-block-bar section" style={{ backgroundColor: '#fdf2e5' }}>
          <div className="container" style={{ marginBottom: '40px' }}>
            <div className="row">
              <div className="col-sm-4">
                <img
                  src="/images/www/new/wbl/WBL-FullyIntegrated.svg"
                  className="image-grow img-responsive"
                />
              </div>
              <div className="col-sm-8">
                <div>
                  <h3>
                    A <b>Fully Integrated</b> Solution
                  </h3>
                  <p style={{ color: ' #000', fontSize: '1rem' }}>
                    By building a work-based learning database directly into the
                    CareerExplorer, we can ensure that everyone has easy access to the
                    data they need. Students can see the opportunities inline while
                    performing their exploration, and can interact with opportunities via
                    their journal, bookmark them, and even apply. Educators and
                    administrators get a centralized repository to update and access
                    contact and offering information for companies as well as manage the
                    pipeline of communication between your students and the community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container section">
          <div className="row" style={{ marginBottom: '40px' }}>
            <div className="col-md-6 col-sm-8">
              <div>
                <h3>
                  Your <b>Local Opportunities</b> Dashboard
                </h3>

                <p style={{ color: ' #000', fontSize: '1rem' }}>
                  The <b>Local Opportunities Network</b> is a digital solution made for
                  CTE and workforce development administrators designed to warehouse and
                  promote local opportunities within your partner companies and
                  organizations. The Local Opportunities Network is directly integrated
                  within the CareerExplorer system, making it easy for users to move from
                  career exploration and planning to finding relevant experience and
                  skills-building opportunities.{' '}
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-4">
              <img
                src="/images/www/new/localopps/1.png"
                style={{ marginBottom: '15px' }}
                className="img-responsive image-grow with-border"
              />
            </div>
          </div>

          <div className="row" style={{ marginBottom: '40px' }}>
            <div className="col-md-5 col-sm-4">
              <img
                src="/images/www/new/localopps/2.png"
                className="img-responsive image-grow with-border"
              />
            </div>
            <div className="col-md-7 col-sm-8">
              <h3>
                Make <b>Partner Participation Easy</b>
              </h3>
              <p style={{ color: ' #000', fontSize: '1rem' }}>
                The <b>Local Opportunities Network</b> makes it easy for local companies
                and organizations to participate in your program and make an impact.
                Partner contacts are never shared directly with students. Administrators
                of the system act as the "gatekeeper" to all local opportunities,
                determining the right fit for the individuals they are working with. To
                join your network all companies have to do is fill in a short and simple
                intake survey.{' '}
              </p>
            </div>
          </div>
          <div className="row" style={{ marginBottom: '40px' }}>
            <div className="col-md-6 col-sm-8">
              <h3>
                Match individuals to <b>the opportunity type</b> that's{' '}
                <b>right for them</b>
              </h3>
              <p style={{ color: ' #000', fontSize: '1rem' }}>
                When students and opportunity seekers use the CareerExplorer they're able
                to easily indicate their interest in the type of opportunity they're
                interested in directly from occupation listings as well as from the
                Opportunities Hub. Administrators can configure "applications" to local
                opportunities or they may choose a more simplified process... it's up to
                you!
              </p>
            </div>
            <div className="col-md-6 col-sm-4">
              <div className={'col-md-6 col-xs-12'} style={{ padding: '5px' }}>
                <img
                  src="/images/headed2/new/localopportunities/H2-WBL-Banner-Advisory.svg"
                  className="img-responsive image-grow"
                />
              </div>
              <div className={'col-md-6 col-xs-12'} style={{ padding: '5px' }}>
                <img
                  src="/images/headed2/new/localopportunities/H2-WBL-Banner-CommunityEngagement.svg"
                  className="img-responsive image-grow"
                />
              </div>
              <div className={'col-md-6 col-xs-12'} style={{ padding: '5px' }}>
                <img
                  src="/images/headed2/new/localopportunities/H2-WBL-Banner-OnSiteTraining.svg"
                  className="img-responsive image-grow"
                />
              </div>
              <div className={'col-md-6 col-xs-12'} style={{ padding: '5px' }}>
                <img
                  src="/images/headed2/new/localopportunities/H2-WBL-Banner-RemoteLearning.svg"
                  className="img-responsive image-grow"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="title-block-bar section"
          style={{
            backgroundColor: '#eee',
            paddingTop: '65px',
            paddingBottom: '65px',
            marginTop: '25px'
          }}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <h3>Student Privacy</h3>
                <p style={{ color: 'black', fontSize: '1rem' }}>
                  <img
                    src="/images/www/new/localopps/LocalOpp-Icon-StudentPrivacy.svg"
                    className="pull-right"
                    style={{ marginLeft: '25px', maxWidth: '110px' }}
                  />
                  Student data is never shared with employers via the{' '}
                  <b>Local Opportunities Network</b> without their expressed consent.
                  Students research opportunities and may share participation surveys and
                  reflections with their teachers and counselors. Students may also
                  complete applications for local opportunities within the system. All
                  student data in the CareerExplorer belongs to the student and remains
                  the property of that student even after they graduate. As a central
                  administrator of Local Opportunities you decide how much access to give
                  students to the companies and organizations in your program.
                </p>
              </div>
            </div>
          </div>
        </div>
        <FeatureBottom state={this.props.match.params.state} />
      </div>
    )
  }
}

export default withRouter(LocalOpportunities)
